module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist_swirl_large.a099d76f.png";